export default __webpack_public_path__ + "static/media/3149.cd507427.jpg";